module.exports = __webpack_public_path__ + "img/ph.f3f9633d.png";